<mat-icon color="primary">mood_bad</mat-icon>
<h3>Error 404 !</h3>
<a
	[routerLink]="['/']"
	color="primary"
	mat-button
>Retour</a>
